 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		89: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"b819209","1":"6b68f82","2":"bc6c71c","3":"9b0d5b6","4":"198d938","5":"569d93a","6":"47d40db","7":"845c5eb","8":"71a30b9","9":"d8b9bf8","10":"67106fd","11":"2eb9b89","12":"c641149","13":"928e6cf","14":"98bb5fa","15":"6b55c30","16":"29ff6ac","17":"cbbdb32","18":"fccf69a","19":"ffe7968","20":"6f4a88b","21":"6094dcb","22":"9c39a6f","23":"d44e1a9","24":"44ea612","25":"4aa7146","26":"617563b","27":"66a09bb","28":"28d2ac0","29":"612ec32","30":"99101a8","31":"5af846a","32":"7bea3e3","33":"b69a2a7","34":"4cdd22f","35":"e34bf7e","36":"c62a84f","37":"59efe2a","38":"fe81b4a","39":"25e6f89","40":"8ee83f9","41":"5047254","42":"ad0751c","43":"a25b89d","44":"738f73b","45":"0e64089","46":"3658462","47":"a6fcdcc","48":"63d2af3","49":"ec6bcc3","50":"2805f46","51":"a9a8b66","52":"7352bb9","53":"6c2c00d","54":"1c70994","55":"57e2c5d","56":"22b6f74","57":"909b598","58":"e7dfcce","59":"fd268d8","60":"15c67d9","61":"a6f121c","62":"e961d48","63":"95abedb","64":"dfb71a6","65":"b14e406","66":"e09b9c9","67":"7e9012d","68":"2300cad","69":"988dcf1","70":"9b3e805","71":"f0a2993","72":"2e02f13","73":"7a7358a","74":"15d500c","75":"3603e6c","76":"0d14599","77":"645b626","78":"c8d33ae","79":"063e332","80":"214958b","81":"b870e6b","82":"dcd6cab","83":"0825e60","84":"73ff1b7","85":"fef2858","86":"bf75638","87":"08ea9f5","88":"4cbb1dc","91":"3ef504c","92":"dcdd63e","93":"104a3bb","94":"9c3c8dc","95":"564e4ff","96":"98a6ee0","97":"2871023","98":"3bc9eba","99":"471bead","100":"233455a","101":"221389c","102":"06c0cd5","103":"06c44e3","104":"ca211e7","105":"7b1460d","106":"9f80f9c","107":"56a1fd1","108":"154ae42","109":"3d2a1fe","110":"2be87b0","111":"9ee4e0b","112":"eed9769","113":"0851032","114":"4aa31a3","115":"f2c574f","116":"85c9b46","117":"7be6974","118":"954a72d","119":"b04602e","120":"2f751e2","121":"9989529","122":"c27c50a","123":"ae7b212","124":"15e15fa","125":"e612eeb","126":"754ce01","127":"5eac539","128":"ac20f57","129":"7f40aa9","130":"45f34db","131":"b3baffe","132":"08e9910","133":"5051844","134":"f33c3a3","135":"efcc881","136":"3ee396f","137":"b180709","138":"df29439","139":"9177532","140":"abb22a2","141":"5ab54b6","142":"be26a59","143":"d87a944","144":"f8de83b","145":"66a6f74","146":"7bd45dd","147":"4ce01c8","148":"33c116a","149":"ceece11","150":"a8061e1","151":"21ba080","152":"4f8aa09","153":"35695b9","154":"7bc46d6","155":"ca53af7","156":"ad0f72f","157":"ff4c111","158":"a268e99","159":"c521a03","160":"20ec746","161":"3990ff5","162":"f1317c7","163":"b0c3b92","164":"19e58b7","165":"f3a2679","166":"56f6aa0","167":"c46517f","168":"2a8ddc0","169":"9e20bd0","170":"27e6584","171":"bc30e13","172":"1f06ddc","173":"7e691d8","174":"a613dfa","175":"6c0d4d9","176":"abb7fea","177":"249d9de","178":"355564e","179":"e19e9c9","180":"206bef8","181":"0c8ae2f","182":"751d130","183":"49203d0","184":"6d73234","185":"69986da","186":"6dfcefd","187":"3521dc6","188":"e4ace7c","189":"2ab0415","190":"60a4bc5","191":"7cd38b0","192":"d48b515","193":"a674670","194":"435bbc9","195":"7715250","196":"fa7768d","197":"7140b53","198":"869fc78","199":"7df98a5","200":"245fc20","201":"87246c0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/cms_1788244782344/blog/2026-unsere_altersbereiche/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([167,90]);
 	// run deferred modules when ready
 	return checkDeferredModules();
